// extracted by mini-css-extract-plugin
export default {"list":"list_list__yyt2M","empty":"list_empty__l9Phu","itemLabel":"list_itemLabel__vcHQN","secondaryText":"list_secondaryText__LLAkM"};